(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-search"]) return;
  try {
    
  (function () {
    function init() {
      var results = document.getElementById('search-results');
      if (!results) return;

      var collectionSelect = document.getElementById('f-collection');
      var genreSelect = document.getElementById('f-genre');
      var stockCheck = document.getElementById('f-stock');
      var countEl = document.getElementById('search-count');
      var emptyEl = document.getElementById('search-empty');
      var hits = Array.prototype.slice.call(results.querySelectorAll('.search-hit'));

      function apply() {
        var col = collectionSelect ? collectionSelect.value : '';
        var genre = genreSelect ? genreSelect.value : '';
        var inStock = stockCheck ? stockCheck.checked : false;
        var shown = 0;

        hits.forEach(function (hit) {
          var ok = true;
          if (col) {
            var owned = ' ' + (hit.dataset.collections || '') + ' ';
            if (owned.indexOf(' ' + col + ' ') === -1) ok = false;
          }
          if (ok && genre) {
            var genres = ' ' + (hit.dataset.genre || '') + ' ';
            if (genres.indexOf(' ' + genre + ' ') === -1) ok = false;
          }
          if (ok && inStock && hit.dataset.available !== 'true') ok = false;
          hit.hidden = !ok;
          if (ok) shown++;
        });

        if (countEl) countEl.textContent = shown + ' resultados';
        if (emptyEl) emptyEl.hidden = shown !== 0;
      }

      if (collectionSelect) collectionSelect.addEventListener('change', apply);
      if (genreSelect) genreSelect.addEventListener('change', apply);
      if (stockCheck) stockCheck.addEventListener('change', apply);
      apply();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
